/*
jqajx.js
requires jQuery

usage:
Invokes callbacks on result.

return:
--
*/

export default {
	getData(the_url, successhandler, errorhandler) {
		jQuery.ajax({
			url: the_url,
			// url: 'http://localhost:9090/betping/rest/api/dummy',
			crossDomain: true
		}).done(res => {
			successhandler(res);
		}).fail(err => {
			errorhandler(err);
		});
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/common/lib/utils/jqajx.js